import { createGlobalStyle } from 'styled-components'

import FontLight from 'styles/fonts/CeraPro/static/CeraPro-Light.ttf'
import FontRegular from 'styles/fonts/CeraPro/static/CeraPro-Regular.ttf'
import FontMedium from 'styles/fonts/CeraPro/static/CeraPro-Medium.ttf'
import FontBold from 'styles/fonts/CeraPro/static/CeraPro-Bold.ttf'

import { fontFace } from './utils/fontFace'

const FontsCss = createGlobalStyle`
  ${fontFace('Inter', FontLight, 300)};
  ${fontFace('Inter', FontRegular, 400)};
  ${fontFace('Inter', FontMedium, 500)};
  ${fontFace('Inter', FontBold, 700)};
`

export default FontsCss
